export default __webpack_public_path__ + "static/hero-top-9b8ba68a2e07e04b537b60369c68a7d5.gif";